<div 
  class="skeleton" 
  [class.ripple]="animation === 'ripple'"
  [class.pulse]="animation === 'pulse'"
  [style.width]="width"
  [style.height]="height"
  [style.border-radius]="borderRadius">
</div>
